import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMoney } from "@/lib/format";

const Stat = ({ label, value, sub, testId }) => (
  <div className="card p-4 sm:p-5" data-testid={testId}>
    <p className="text-xs sm:text-sm text-[#5B665F]">{label}</p>
    <p className="num text-2xl sm:text-3xl font-bold mt-1.5 tracking-tight" data-testid={`${testId}-value`}>{value}</p>
    {sub && <p className="text-xs text-[#5B665F] mt-1">{sub}</p>}
  </div>
);

export default function AdminStats({ refreshKey }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, [refreshKey]);
  if (!s) return <div className="h-[104px]" />;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-8" data-testid="admin-stats">
      <Stat label="Places vendues" value={`${s.seats_sold} / ${s.seats_total}`} sub={`${s.seats_link + s.seats_stripe} lien Stripe · ${s.seats_transfer} virement · ${s.seats_manual} ajustement`} testId="stat-seats" />
      <Stat label="Montant encaissé" value={fmtMoney(s.revenue)} testId="stat-revenue" />
      <Stat label="Rappels à faire" value={s.callbacks_todo} testId="stat-callbacks" />
      <Stat label="Virements en attente" value={s.transfers_pending} testId="stat-transfers" />
      <Stat label="Clubs inscrits" value={s.clubs} sub="hors compte de démo" testId="stat-clubs" />
    </div>
  );
}
